(() => {
  if (window.southwoodCollectionNavigation) return;
  window.southwoodCollectionNavigation = true;
  let pending = false;
  const format = (value, data) => value.replace(/\{(\w+)\}/g, (_, key) => data[key]);
  const observer = new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; enhance(); });
  });
  function enhance() {
    observer.disconnect();
    const config = document.querySelector('[data-sw-collection-config]');
    const section = document.querySelector('#shopify-section-collection_page');
    const holder = section?.querySelector('.products');
    if (config && holder) {
      section.querySelectorAll('.sw-collection-top,.sw-collection-range,.sw-page-count').forEach(el => el.remove());
      const nav = section.querySelector('.nt-pagination');
      const current = Number(nav?.querySelector('.current')?.textContent) || 1;
      const offsets = nav?.querySelector('[data-js-arr_offsets]')?.textContent.trim().split(';;;');
      const numbers = Array.from(nav?.querySelectorAll('.page-numbers') || []).map(el => Number(el.textContent)).filter(Number.isFinite);
      const pages = offsets?.length || Math.max(1, ...numbers);
      const limit = Number(JSON.parse(holder.getAttribute('data-filterntt4') || '{}').limit_ntt4) || holder.querySelectorAll(':scope > .product').length || 20;
      const count = holder.querySelectorAll(':scope > .product').length;
      const countText = section.querySelector('.sp_result_html .cp')?.textContent;
      const total = Number(countText?.replace(/[^0-9]/g, '') || config.dataset.total);
      const start = count ? (current - 1) * limit + 1 : 0;
      const end = count ? Math.min(start + count - 1, total) : 0;
      const range = document.createElement('p');
      range.className = 'sw-collection-range';
      range.textContent = format(config.dataset.range, {start, end, total});
      const top = document.createElement('div');
      top.className = 'sw-collection-top';
      top.hidden = !!section.querySelector('.sp_result_html') && !countText;
      top.append(range);
      if (nav && pages > 1) {
        nav.querySelectorAll('a[href]').forEach(link => link.setAttribute('href', link.getAttribute('href').replace(/&amp;/g, '&')));
        nav.classList.add('sw-collection-pagination');
        nav.setAttribute('aria-label', config.dataset.label);
        nav.querySelector('.current')?.setAttribute('aria-current', 'page');
        const pageText = format(config.dataset.page, {current, total: pages});
        const compact = document.createElement('nav');
        compact.className = 'sw-collection-compact paginate_ajax';
        compact.setAttribute('aria-label', config.dataset.label);
        const pageCount = document.createElement('span');
        pageCount.className = 'sw-page-count';
        pageCount.textContent = pageText;
        ['prev', 'next'].forEach((direction, index) => {
          const source = nav.querySelector('a.' + direction);
          const enabled = source && !source.classList.contains('hide');
          const label = index ? config.dataset.next + ' →' : '← ' + config.dataset.previous;
          if (source) source.textContent = label;
          const button = enabled ? source.cloneNode(true) : document.createElement('span');
          button.className = 'sw-page-button ' + direction;
          button.textContent = label;
          if (!enabled) button.setAttribute('aria-disabled', 'true');
          compact.append(button);
          if (!index) compact.append(pageCount);
        });
        top.append(compact);
        const bottomCount = pageCount.cloneNode(true);
        nav.append(bottomCount);
        const bottomRange = range.cloneNode(true);
        nav.before(bottomRange);
      }
      holder.before(top);
    }
    const root = document.querySelector('#nt_content') || document.body;
    observer.observe(root, {childList: true, subtree: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance, {once: true});
  else enhance();
})();
